module.exports = __webpack_public_path__ + "img/circumstances.822d60f3.png";